<tab-container>
    <ng-template tab-pane [canDeactivate]="canDeactivate()" title="Materials" [hasData]="_stateMap.hasMaterialDataFor('relations-materials')" >
        <relations-materials></relations-materials>
    </ng-template>
    <ng-template tab-pane [canDeactivate]="canDeactivate()" title="Groups" [hasData]="_stateMap.hasMaterialDataFor('relations-groups')" >
        <relations-groups></relations-groups>
    </ng-template>
</tab-container>
